import { useQuery } from "@apollo/client";
import { GET_CLIENT_INBOUND_CONFIGS } from "../queries/clients";

/**
 * @typedef {Object} InboundConfig
 * @property {string} address
 * @property {string} createTime
 * @property {string} lastModifiedTime
 * @property {number} clientId
 * @property {number} userId
 * @property {boolean} enabled
 * @property {boolean} createPatient
 * @property {boolean} createReferral
 * @property {boolean} createServiceRequest
 * @property {string} mrnOid
 */

/**
 * @typedef {Object} UseClientInboundConfigsResult
 * @property {InboundConfig[]} inboundConfigs
 * @property {boolean} loading
 * @property {Error|null} error
 */

/**
 * Custom hook - fetch inbound configs.
 *
 * @param {number} clientId
 * @param {Object} [options]
 * @returns {UseClientInboundConfigsResult}
 */
export const useClientInboundConfigs = (clientId, options = {}) => {
  const skip = !clientId;

  const { data, loading, error } = useQuery(GET_CLIENT_INBOUND_CONFIGS, {
    variables: { clientId },
    skip,
    notifyOnNetworkStatusChange: true,
    ...options,
  });

  const inboundConfigs = data?.inboundConfigs ?? [];

  return {
    inboundConfigs,
    loading,
    error,
  };
};
